import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";

import { XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useSportsRepository } from "@/pages/sports/hooks/use-sports-repository";

/** Shows (and clears) the team behind a deep-linked `/matches?teamId=`. */
export function TeamFilterChip() {
  const { getTeam } = useSportsRepository();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const teamId = params.get("teamId");
  const [name, setName] = useState<string>();

  useEffect(() => {
    setName(undefined);
    if (!teamId) return;
    let cancelled = false;
    getTeam(teamId)
      .then((team: any) => {
        if (!cancelled) setName(team?.name ?? team?.shortName ?? teamId);
      })
      .catch(() => {
        if (!cancelled) setName(teamId);
      });
    return () => {
      cancelled = true;
    };
  }, [teamId]);

  if (!teamId) return null;

  return (
    <div className="flex h-9 items-center gap-1 rounded-md border px-3 text-sm">
      <span>Team: {name ?? teamId}</span>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-6"
        aria-label="Clear team"
        onClick={() => {
          const next = new URLSearchParams(params);
          next.delete("teamId");
          const qs = next.toString();
          navigate(qs ? `/matches?${qs}` : "/matches");
        }}
      >
        <XIcon className="size-4" />
      </Button>
    </div>
  );
}
